export default {
  empresaID: null,
  tipoTermo: null,
  solicitanteID: null,
  dataSolicitacao: null,
  aprovadorID: null,
  dataAprovação: null,
  obraID: null,
  obraRHID: null,
  responsavelID: null,
  favorecidoID: null,
  secaoRHID: null,
  equipe: null,
  valorSolicitado: null,
  justificativa: null,
  pedido: null,
  motivoViagemID: null,
  dataViagemInicio: null,
  dataViagemFim: null,
  paisOrigemID: null,
  paisDestinoID: null,
  estadoOrigemID: null,
  estadoDestinoID: null,
  cidadeOrigemID: null,
  cidadeDestinoID: null,
  filename: '',
  file: []
}



// WEBPACK FOOTER //
// ./src/shared/models/business/acceptterm.js